import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

import { FilledButton } from 'shared-components/Buttons';
import Logo from 'images/adpkd-registry-logo.svg';
import { ADPKDArea, Container, Content, PKDLogo } from '../common/styles';
import Background from '../common/Background';

const Start = ({ data, onStart }) => {
  return (
    <Container>
      <ADPKDArea>
        <PKDLogo
          src={Logo} alt='pkd logo'
        />
      </ADPKDArea>
      <Stack
        alignItems='center' sx={{ position: 'relative' }}>
        <Box
          sx={{ display: { md: 'none', xs: 'contents' } }}>
          <Background
            style={{ position: 'absolute' }}
          />
        </Box>
        <Content>
          <Typography
            variant='h1' mb={4}>
            {data?.meta_title}
          </Typography>
          <Typography
            variant='body1'
            mb={4}
            dangerouslySetInnerHTML={{ __html: data?.meta_description }}
            style={{ overflowY: 'auto' }}
          />

          <FilledButton
            style={{ marginBottom: '20px' }}
            fullWidth
            background='#00778B'
            height='44px'
            width='200px'
            onClick={onStart}>
            Next
          </FilledButton>
        </Content>
      </Stack>
    </Container>
  );
};

export default Start;
